import { NewOrderType, TNewOrderType } from "@/entities/new-order";
import { Checkbox } from "@/shared/ui/checkbox";
import { Select } from "@/shared/ui/select";
import { ComboboxItem, Flex, Text } from "@mantine/core";
import { ChangeEvent, ForwardedRef, forwardRef } from "react";

const typesSelectData: ComboboxItem[] = [
  {
    value: NewOrderType.install,
    label: "Installs",
  },
  {
    value: NewOrderType.rate,
    label: "Rates",
  },
  { value: NewOrderType.review, label: "Reviews" },
];

const selectValue = {
  [NewOrderType.rate]: NewOrderType.rate,
  [NewOrderType.install]: NewOrderType.install,
  [NewOrderType.install_bp]: NewOrderType.install,
  [NewOrderType.install_with_views]: NewOrderType.install,
  [NewOrderType.review]: NewOrderType.review,
};

type TNewOrderTypeSelectProps = {
  value: TNewOrderType;
  onChange: (value: TNewOrderType) => void;
  disabled?: boolean;
  error?: string | boolean;
};

export const NewOrderTypeSelect = forwardRef(
  (
    { value, onChange, disabled, error }: TNewOrderTypeSelectProps,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const handleToggleBp = (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        onChange(NewOrderType.install_bp);
      } else {
        onChange(NewOrderType.install);
      }
    };

    return (
      <Flex align="center" gap={16} ref={ref}>
        <Select
          value={value ? selectValue[value] : null}
          data={typesSelectData}
          w={418}
          onChange={(value) => {
            onChange(value as TNewOrderType);
          }}
          placeholder="Choose type"
          disabled={disabled}
          error={error}
        />
        {value !== NewOrderType.rate ? (
          <Flex gap={8}>
            <Checkbox
              name="order_type"
              checked={value === NewOrderType.install_bp}
              isDisabled={disabled}
              onChange={handleToggleBp}
            />
            <Text>by package</Text>
          </Flex>
        ) : null}
      </Flex>
    );
  },
);
